import React, {Component} from "react";
import DateTime, {defaultDateTime} from "./DateTime";

const When = (props) => (
    <div style={{display: "inline-block", verticalAlign: "top"}}>
        {props.value === null ?
            <span className="x-now">Now <button type="button" className="x-change-button button-as-link" onClick={() => props.onChange(defaultDateTime())}>change</button></span>
            :
            <span>
                <DateTime id="disseminatedOn" value={props.value.asEntered} onChange={props.onChange} />
                <br />
                <button type="button" className="x-reset-to-now-button button-as-link" onClick={() => props.onChange(null)}>reset to now</button>
            </span>
        }
    </div>
);

When.propTypes = {
    onChange: React.PropTypes.func,
    value: React.PropTypes.shape({
        asEntered: React.PropTypes.shape({
            date: React.PropTypes.string,
            time: React.PropTypes.string,
            timezone: React.PropTypes.string
        }),
        instant: React.PropTypes.string
    })
};

export default When;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/common/components/When.js
 **/